import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Container from 'react-bootstrap/Container';

import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import { Routes, Route, Navigate, useNavigate, useParams } from 'react-router-dom'
import './App.css';
import Carousel from 'react-bootstrap/Carousel';

import data from './fruits.js';
import data2 from './main.js';
import data3 from './infor.js';
import data4 from './blog.js';
import data5 from './foo.js';

import Detail from './Detail';
import Cart from './Cart.js'
import Latestblog from './Latestblog';
import { useState } from 'react';


function App() {

let [fruits] = useState(data);
let [main, setMain] = useState(data2);
let [res1, setRes1] = useState([0,1,2,3,4,5,6,7]);
let [infor] = useState(data3);
let [blog] = useState(data4);
let [foo] = useState(data5);

let [tap, setTap] = useState(0);   

let navigate = useNavigate();

  return (
    <>
    <div className="d-none d-md-block">
      <div id="whole">
        <div className='container' id="hide" style={{padding:0}}>
          <div className='top_mess'>012 3456 789</div>
          <div className='top_mess'>Welcome to our online store!</div>
          <div className='top_mess'>
            <NavDropdown title="United States (USD $)" id="navbarScrollingDropdown">
              <NavDropdown.Item href="#action3">Germany (EUR)</NavDropdown.Item>
              <NavDropdown.Item href="#action4">
                United States (USD)
              </NavDropdown.Item>
            </NavDropdown>

            <NavDropdown title="English" id="navbarScrollingDropdown">
              <NavDropdown.Item href="#action3">Korean</NavDropdown.Item>
              <NavDropdown.Item href="#action4">English</NavDropdown.Item>
            </NavDropdown>
          </div>

        </div>
      </div>
    </div>


    <div className="main_nav">
      <div className='container' style={{padding:0}}>
      <Navbar id="nav" expand="lg">
          <Container fluid id="container" style={{padding:0}}>
            <Navbar.Brand href="#"><img src='img/111.jpg' id='logo'/></Navbar.Brand>
            <Navbar.Toggle aria-controls="navbarScroll" />
            <Navbar.Collapse id="navbarScroll">
              <Nav className="me-auto my-2 my-lg-0" style={{ maxHeight: '150px', zIndex:"200" }}
            navbarScroll >
                <Nav.Link onClick={()=>{navigate('/')}}>Fresh Fruit</Nav.Link>
                <Nav.Link onClick={()=>{navigate('/detail/0')}}>Seasonal Fruits</Nav.Link>
                <Nav.Link onClick={()=>{navigate('/cart')}}>Organic Cart</Nav.Link>
                <NavDropdown title="Vegetable" id="navbarScrollingDropdown">
                  <NavDropdown.Item onClick={()=>{navigate('/detail/1')}}>Best item</NavDropdown.Item>
                  <NavDropdown.Item onClick={()=>{navigate('/detail/2')}}>Another fruit</NavDropdown.Item>
                  <NavDropdown.Divider />
                  <NavDropdown.Item onClick={()=>{navigate('/detail/5')}}>
                    Something else
                  </NavDropdown.Item>
                </NavDropdown>
                <Nav.Link onClick={()=>{navigate('/latestblog')}}>Blog</Nav.Link>
        
              </Nav>
                <img src="img/search.png" id="search"/>
                <img src="img/person.png" id="person"/>
                <Button id="item">2 Item</Button>
            </Navbar.Collapse>
          </Container>
      </Navbar>
    </div>


    <Routes>
      {/* 홈 화면에서 보여지는 부분 */}
      <Route path="/" element={
      
      <div>

          {/* 슬라이더 */}

          <div className='slider'>
            <SliderContent></SliderContent>
          </div>

          {/* 카테고리부분, 화면크기 작아지면 아예 보이지않음 */}

          <div className="d-none d-md-block">
            <Title1/>
            <div className="container">
              <div className="row">
              
                  {
                    fruits.map((a,i)=>{
                      return(
                        <Product fruits={fruits[i]} i={i+1} key={i}></Product>
                      )
                    })
                  }
              </div>
            </div> 
          </div> 

          <Title2/>

          <div id="trending">
            <Button variant="outline-success" className='buttons' onClick={()=>{
              let copy3 = [...main].sort((a,b)=>
                a.title > b.title ? 1:-1
              );

              setMain(copy3);
              main=copy3;

              var res=[];
              for(let i in main) {
                res.push(main[i].id);
              }

              setRes1(res1=res);

            }}>Featured</Button>

            <Button variant="outline-success" className='buttons' onClick={()=>{
              let copy4=[...main].sort((a,b)=>
                a.price > b.price ? 1:-1
              );

              setMain(copy4);
              main=copy4;
              var res=[];
              for(let i in main){
                res.push(main[i].id);
              }
              setRes1(res1=res);

            }}>Low Price</Button>
            <Button variant="outline-success" className='buttons' onClick={()=>{
              let copy3 = [...main].sort((a,b)=>
              a.demo > b.demo? 1:-1
            );

            setMain(copy3);
            main=copy3;

            var res=[];
            for(let i in main) {
              res.push(main[i].id);
            }

            setRes1(res1=res);

            }}>Bestseller</Button>
          </div>

          {/* 메인 제품들 */}

          <div className='container'>
            <div className='row'>
              {
                main.map((a,i)=>{
                  return(
                    <Main main={main[i]} res1={res1} i={i} key={i}></Main>
                  )
                })
              }
            </div>
          </div>

          {/* 4개 박스 */}

          <div className='container' style={{margin:"90px auto"}}>
            <div className='row'>
              {
                infor.map((a,i)=>{
                  return(
                    <Information infor={infor[i]} i={i+1} key={i}></Information>
                  )
                })
              }
            </div>
          </div>

          {/* 과일 두개 */}

          <div className='container' style={{marginBottom:"50px"}}>
            <div className='row'>
              <div className='col-md-6'>
                <div className='col-md-12' id="mid1">
                  <MiddleText></MiddleText>
                </div>
              </div>
              <div className='col-md-6'>
                <div className='col-md-12' id="mid2">
                  <MiddleText></MiddleText>
                </div>
              </div>
            </div>
          </div>

          {/* 배경 고정 */}

          <div id="blackBox">
            <BlackTitle></BlackTitle>
            <TabContent tap={tap}/>
            
            <ul defaultactivekey="link0" className='tapUl'>
                <li onClick={()=>{ setTap(0) }} eventkey="link0" className='circle'></li>
                <li onClick={()=>{ setTap(1) }} eventkey="link1" className='circle'></li>
                <li onClick={()=>{ setTap(2) }} eventkey="link2" className='circle'></li>
            </ul>

          </div>

          <div className='container-fluid'>
            <div className='row'>
              <div className='col-md-4' id='cut1'>
                <Plus></Plus>
              </div>
              <div className='col-md-4' id="cut2">
                <Plus2></Plus2>     
              </div>
              <div className='col-md-4' id='cut3'>
                <Plus3></Plus3>
              </div>
              
            </div>
          </div>

          <Title3 />

          <div className='container'>
            <div className='row'>
              {
                blog.map((a,i)=>{
                  return(
                    <Blog blog={blog[i]} i={i+1} key={i}></Blog>
                  )
                })
              }
            </div>
          </div>

        </div>} />

        <Route path="/detail/:id" element={<Detail main={main}/>} />
        <Route path="/cart" element={<Cart/>}/>
        <Route path='/latestblog' element={<Latestblog />}></Route>

      </Routes>
          </div>

        <Footer foo={foo}></Footer>
    </>
  );
}

// APP 컴포넌트 아래부분


function SliderContent () {
 
  return (
    <Carousel>
       <Carousel.Item>
      <div className='slidercontents'>
        <div className='wrapText'>
          <h1>Organic fresh fruits for your health</h1>
          <div className="d-none d-md-block">
          <p>Interdum et malesuada fames ac ante ipsum primis in 
            faucibus. Mauris eleifend sagittis mollis. 
            Nulla finibus arcu eu tortor gravida aliquet</p>
            </div>
          <button>SHOP NOW</button>
        </div>
      </div>
      </Carousel.Item>
      <Carousel.Item>
      <div className='slidercontents2'>
        <div className='wrapText'>
          <h1>Organic fresh fruits for your health</h1>
          <div className="d-none d-md-block">
          <p>Interdum et malesuada fames ac ante ipsum primis in 
            faucibus. Mauris eleifend sagittis mollis. 
            Nulla finibus arcu eu tortor gravida aliquet</p>
            </div>
          <button>SHOP NOW</button>
        </div>
      </div>
      </Carousel.Item>
    </Carousel>
  );
};


function Title1 () {
  return (
    <>
    <h2 id="topCategory">Top Category</h2> 
    </>
  );
};

function Title2 () {

  return (
    <>
    <h2 id="trendingPro">Trending Product</h2> 
    </>
  );
};


function Product (props) {

  return (
    <div className='col-md-2' style={{textAlign:"center"}}>
      <img src={'img/fruits'+props.i+'.jpg'} id="productImg"/>
      <h5 id="productTitle">{props.fruits.title}</h5>
    </div>
  );
};

//과일들
function Main (props) {

  let navigate = useNavigate();
  let people = Math.floor(Math.random()*100);

  return (
      <div className='col-md-3' style={{marginBottom:"25px"}}>
        <div className='col-md-12' id="trendingBox">
          <Nav.Link onClick={() => {navigate('/detail/'+ props.res1[props.i]) }} className="na">
            <div id='mainImg'>
              <img src={props.main.imgUrl} width="100%" height="100%"/>
            </div>
            <div id="mainText">
              <p>{props.main.contents}</p>
              <p>{props.main.title}</p>
              <h5>{props.main.price}</h5>
            </div>
              <button className='mainBtn'>{people} people are buying !</button>
          </Nav.Link> 
        </div>
      </div>
  );
};

function Information (props) {
  return (

      <div className='col-md-3' style={{textAlign:"center"}}>
        <div id="inforImg">
          <img src={'img/information'+props.i+'.png'} width="51%"/>
        </div>
        <p id="inforTitle">{props.infor.title}</p>
        <p id="inforCon">{props.infor.contents}</p>
      </div>
  );
};


function MiddleText () {

  return (
    <div id="midBox">
      <p>Summer</p>
      <h2>Fresh Fruit, Vegetables</h2>
      <p>Up To 25% Off Fruit</p>
      <button className="midBtn">SHOP NOW</button>
    </div>
  );
};


function BlackTitle () {
  
  return (
      <h3 id="BlackTitle">Testimonials</h3>
  );
};

// 슬라이드 부분

function TabContent(props){
  return [ <Testimonials></Testimonials>, <Testimonials2></Testimonials2>,
   <Testimonials3></Testimonials3> ][props.tap]
}

function Testimonials () {

  return (
      <div id="black">
            <img src='img/profile.jpg'/>
        <p>Thank you for letting me be a part of such a fantastic event! 
          Being a volunteer for this race is much more than just work, 
          it’s an unforgettable experience that will stay with me 
          for the rest of my life.</p>
          <h5>Mr.John Deo</h5>
      </div>

  );
};

function Testimonials2 () {

  return (
      <div id="black">
  
            <img src='img/profile2.jpg'/>

        <p>Curabitur nec pellentesque ligula. 
          Duis tincidunt ante nisl, non ultrices nisl 
          imperdiet vitae. Vestibulum maximus malesuada 
          tortor et vulputate. Etiam malesuada quam 
          vestibulum, scelerisque odio nec, 
          interdum turpis. Mauris hendrerit egestas libero, 
          eget pellentesque lacus sodales a.</p>
          <h5>Mr.Onsequat</h5>
      </div>

  );
};

function Testimonials3 () {

  return (
      <div id="black">

            <img src='img/profile3.jpg'/>

        <p>Thank you for letting me be a part of such a fantastic event! 
          Being a volunteer for this race is much more than just work, it’s an 
          unforgettable experience that will stay with me 
          for the rest of my life.</p>
          <h5>Mr.Muis tel</h5>
      </div>

  );
};

function Plus () {

    let [pop,setPop] = useState(false);
  return (
      <>
      <button className="plus" onMouseOver={()=>{setPop(true)}}
      onMouseLeave={()=>{setPop(false)}}>
        +
      </button>
      {pop == true ? <Popup></Popup> : null}
      </>
      
  );
};


function Popup () {
  
  return (
    <div className='pop'>
      <img src='/img/main4.jpg' width="70%"></img>
      <p>Winter Veggies</p>
      <p>$390.00</p>
      <span>Best Product</span>
    </div>
  );
};

function Plus2 () {

    let [pop,setPop] = useState(false);
  return (
      <>
      <button className="plus2" onMouseOver={()=>{setPop(true)}}
      onMouseLeave={()=>{setPop(false)}}>
      +
      </button>
      {pop == true ? <Popup2></Popup2> : null}
      </>
      
  );
};

function Popup2 () {

  return (
    <div className='pop'>
      <img src='/img/main3.jpg' width="70%"></img>
      <p>Summer Price</p>
      <p>$195.00</p>
      <span>MD's Pick</span>
    </div>
  );
};

function Plus3 () {

    let [pop,setPop] = useState(false);
  return (
      <>
      <button className="plus3" onMouseOver={()=>{setPop(true)}}
      onMouseLeave={()=>{setPop(false)}}>
      +
      </button>
      {pop == true ? <Popup3></Popup3> : null}
      </>
      
  );
};

function Popup3 () {

  return (
    <div className='pop'>
      <img src='/img/main4.jpg' width="70%"></img>
      <p>Best Price</p>
      <p>$98.00</p>
      <span>Good Price</span>
    </div>
  );
};


function Title3 () {
  return (
    <>
    <h2 id="blogTitle">Latest Blog</h2> 
    </>
  );
};


function Blog (props) {

  let num = Math.floor(Math.random()*10);

  return (
    <div className='col-md-4' style={{margin:"2% 0%"}}>
      <div className='col-md-12' id="blogBox">
        <div id="blogImg">
          <img src={'img/blog'+props.i+'.jpg'} />
        </div>
        <div id="blogText">
          <p>{num+props.blog.comment}</p>
          <p>{props.blog.title}</p>
          <p>{props.blog.contents}</p>
        </div>
      </div>
    </div>
  );
};

function Footer (props) {

 let label={
  color:"#fff",
  fontSize:"27px",
  margin:"28px 0px"
 }


  let input={
    width:"80%",
    margin:"0 10px 0 0px"
  }

  
  return (
    <div id="footer">
      <div style={{borderBottom:"1px solid #eee", height:"240px"}}>
        <Form>
          <Form.Group className="mb-3" controlId="formBasicEmail">
            <Form.Label style={label}>SIGN UP TO NEWSLETTER</Form.Label>
            <div id="formBox">
              <Form.Control type="email" placeholder="Enter email" style={input}/>
              <Button variant="success" type="submit">
              Submit
              </Button>
            </div>
            <Form.Text className="text-muted">
            To get the latest news from us please subscribe your email.
            </Form.Text>
          </Form.Group>
        </Form>
      </div>

      <FooUl foo={props.foo}></FooUl>

      <Last></Last>

    </div>
 
  );
};


function FooUl (props) {
  let box={
    borderBottom:"1px solid #eee",
    padding:"70px"
  }
  return (
    <div className='container-fluid' style={box}>
      <div className='row'>
      {
        props.foo.map((a,i)=>{
          return(
            <FooUl2 foo={props.foo[i]} key={i}></FooUl2>
          )
        })
      }
      </div>
    </div>
 

  );
};

function FooUl2 (props) {

  return (

        <div className='col-md-3'>
          <ul id="footerUl">
            <li id="footerLi1">{props.foo.title}</li>
            <li id="footerLi2">{props.foo.con1}</li>
            <li id="footerLi2">{props.foo.con2}</li>
            <li id="footerLi2">{props.foo.con3}</li>
            <li id="footerLi2">{props.foo.con4}</li>
            <li id="footerLi2">{props.foo.con5}</li>
          </ul>
        </div>

  );
};


function Last () {

  let css={
    padding:"3px",
    margin:0,
    color:"#fff",
    fontSize:"11px"
  }

  return (
      <>
        <p style={css}>© 2022, freshgo-webibazaar Powered by Shopify</p>
      </>
  );
};

export default App;
